import { useSelector } from 'react-redux';

import { useApplicationContext } from '../../containers/ApplicationContext';
import { selectIsDailyRentOtaConversionExperimentActive } from '../../selectors/experiments/selectIsDailyRentOtaConversionExperimentActive';

export function useDailyRentOtaConversionExperimentEnabled() {
  const { config } = useApplicationContext();
  const isExperimentActive = useSelector(selectIsDailyRentOtaConversionExperimentActive);
  const isParticipateInExperiment = Boolean(
    config.get<boolean>('Dailyrent.WithoutInstantBookingFilterExperiment.Enabled'),
  );

  return isParticipateInExperiment && isExperimentActive;
}
